/** `RRSP.date_from` / `date_to` are **compact `YYYYMMDD` integers**, not dates.
 *
 * The table stores them that way (it is the same format `rrsp_prices_stmt` reads in v2), so the
 * form has to convert in both directions: date pickers speak `Date`, the table speaks `20260731`.
 */

const pad = value => String(value).padStart(2, '0')

export const compactToDate = value => {
    const raw = String(value ?? '')
    if (raw.length !== 8) return null
    return new Date(Number(raw.slice(0, 4)), Number(raw.slice(4, 6)) - 1, Number(raw.slice(6, 8)))
}

export const dateToCompact = date => {
    if (!date) return null
    return Number(`${date.getFullYear()}${pad(date.getMonth() + 1)}${pad(date.getDate())}`)
}

export const formatCompactDate = value => {
    const raw = String(value ?? '')
    if (raw.length !== 8) return '—'
    return `${raw.slice(0, 4)}-${raw.slice(4, 6)}-${raw.slice(6, 8)}`
}

/** Do two `YYYYMMDD` windows overlap? Compact integers compare as numbers, so this is arithmetic.
 *
 * An open end (`null`) is treated as unbounded, which is how a row with no `date_to` behaves when
 * the reference price is resolved.
 */
export const windowsOverlap = (aFrom, aTo, bFrom, bTo) => {
    const start = value => value ?? 0
    const end = value => value ?? 99999999
    return start(aFrom) <= end(bTo) && start(bFrom) <= end(aTo)
}
